import React from 'react'

export const SVG_Phone = (props: { color?: string }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 96">
        <path
            fill={props.color || '#7D889F'}
            d="m81.5 60.5-8.8-8.9a8.4 8.4 0 0 0-12 0l-3.8 3.7c-3.7-1.5-7-3.8-9.8-6.6-2.8-2.8-5-6.2-6.6-9.8l3.6-3.7a8.4 8.4 0 0 0 0-12l-8.8-8.9a8.4 8.4 0 0 0-12 0l-7.5 7.5a13.3 13.3 0 0 0-3.7 7c-.5 2.6-.2 5.4.8 7.9a87.5 87.5 0 0 0 46 46.1 13.1 13.1 0 0 0 10.6 0c1.6-.7 3.1-1.7 4.4-3l7.5-7.5a8.4 8.4 0 0 0 0-12Zm-21.3 1.4 5.3-5.3c.3-.3.7-.5 1.1-.5s.8.2 1.1.5l8.9 8.9c.1.1.3.3.3.5l.1.6-.1.6-.3.5-7.5 7.5c-.9.9-2.1 1.6-3.4 1.8-1.3.3-2.6.1-3.8-.4a80.3 80.3 0 0 1-42.3-42.5 6.5 6.5 0 0 1-.4-3.9 7 7 0 0 1 1.8-3.4l7.5-7.5c.1-.1.3-.3.5-.3l.6-.1.6.1c.2 0 .4.2.5.3l8.8 9c.3.3.5.7.5 1.1l-.1.6c0 .2-.2.4-.3.5l-5.3 5.3a5 5 0 0 0-.9 1.6v1.8a37.5 37.5 0 0 0 23.4 23.5c.6.2 1.2.2 1.8 0 .6-.1 1.2-.5 1.6-.9Z"
        />
    </svg>
)
